import { useState, useEffect } from "react";
import { retailerService } from "../../services/RetailerService";

function useRetailers(page: number | undefined): [any, boolean] {
  const [result, setResult] = useState({
    retailers: [],
    hasMore: true,
    cursor: "",
    total: 0,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function () {
      try {
        if (result.hasMore) {
          const result = await retailerService.getAll(page ? page : 1);
          if (result.status !== 200) {
            throw new Error("Failed to fetch!");
          } else {
            setResult(result.data);
          }
        }
      } catch (err: any) {
        const error = err.toString();
        //message.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return [result, loading];
}

export default useRetailers;
